export default __webpack_public_path__ + "static/media/035-knot.dbada655.png";